import { frontendURL } from 'dashboard/helper/URLHelper';
import { FEATURE_FLAGS } from 'dashboard/featureFlags';

const CatalogIndex = () => import('./pages/CatalogIndex.vue');
const CatalogDetail = () => import('./pages/CatalogDetail.vue');

const meta = {
  featureFlag: FEATURE_FLAGS.WA_CATALOG,
  permissions: ['administrator', 'agent'],
};

const waCatalogRoutes = {
  routes: [
    {
      path: frontendURL('accounts/:accountId/wa-catalog'),
      component: CatalogIndex,
      name: 'wa_catalog_index',
      meta,
    },
    {
      path: frontendURL('accounts/:accountId/wa-catalog/:catalogId'),
      component: CatalogDetail,
      name: 'wa_catalog_detail',
      meta,
      props: true,
    },
  ],
};

export default waCatalogRoutes;
